import { LIGHT, MUTE, GOLD, BASE, BODY, MONO } from '../lib/constants';
import { Horizon, Btn, Dp, Bd, Mo, GlassCard } from './shared';

/* ═══════════════════════════════════════════════════════════════
   BATCH 7: Privacy Policy Screen
   Required for Apple App Store approval
   ═══════════════════════════════════════════════════════════════ */

export function PrivacyScreen({ onBack }) {
  return (
    <div style={{ position: 'relative', minHeight: '100vh', background: BASE, padding: '20px 16px' }}>
      <Horizon intensity={0.3} />
      
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 600, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <button
            onClick={onBack}
            style={{
              background: 'transparent', border: 'none', color: GOLD,
              fontFamily: MONO, fontSize: 11, fontWeight: 600, cursor: 'pointer',
              marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6
            }}
            data-testid="back-btn"
          >
            ← BACK
          </button>
          <Dp style={{ fontSize: 28, fontWeight: 800, color: LIGHT, marginBottom: 8 }}>Privacy Policy</Dp>
          <Bd style={{ fontSize: 13, color: MUTE }}>Last updated: January 2026</Bd>
        </div>

        {/* Content */}
        <div style={{ fontFamily: BODY, fontSize: 14, color: LIGHT, lineHeight: 1.8 }}>
          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>1. Information We Collect</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              Dettio collects information you provide directly, including your email, name, and financial data you choose to enter (debts, payments, spending data). We also collect data from third-party services like Plaid when you connect your bank accounts.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>2. How We Use Your Information</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              We use your information to provide the Dettio service, including debt tracking, spending analysis, and AI-powered financial insights. We analyze your data to generate personalized recommendations but do not sell your data to third parties.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>3. Data Security</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              Your financial data is encrypted in transit and at rest. We use industry-standard security practices to protect your information. Bank connections are secured through Plaid, which uses bank-level encryption.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>4. Data Sharing</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              We do not sell or share your personal financial data with third parties for marketing purposes. We share data only with service providers necessary to operate Dettio (e.g., Plaid for bank connections, Anthropic for AI insights).
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>5. Your Rights</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              You have the right to access, correct, or delete your data at any time. You can delete your account and all associated data from the Settings screen. Data deletion is permanent and cannot be undone.
            </Bd>
          </GlassCard>

          <GlassCard>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>6. Contact Us</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              For questions about this Privacy Policy or your data, contact us at privacy@dettio.com
            </Bd>
          </GlassCard>
        </div>
      </div>
    </div>
  );
}
